module.exports = __webpack_public_path__ + "img/worldwide.e015771.png";